module.exports = __webpack_public_path__ + "static/media/logo-regenera.16b04fd9.svg";